// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fca87406","239":"bdf9f906","732":"764025b1"}[chunkId] + ".chunk.js";
};